/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

import React from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';

/**
 * Fix restriction with target='_blank'
 * https://github.com/cure53/DOMPurify/issues/317
 */
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

/**
 * Sanitize Component
 * @param value
 * @returns {Element}
 * @constructor
 */
export function Sanitize({ value }) {
  const sanitized = DOMPurify.sanitize(value);
  return (
    <p dangerouslySetInnerHTML={{ __html: (sanitized) }} />
  );
}

Sanitize.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};
